/**************
 Global
 ***************/

// initialize all tippy tooltips
tippy('[data-tippy-content]');

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // klaviyo tracking might not be enabled, we enclose it in a try/catch
    try {
        klaviyo.push(['track', 'Added to Cart', item]);
    } catch (e) {
        // skip
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// given a handle, send an Added to Cart event to Klaviyo
function klaviyoAddToCart(productHandle) {
    fetch(`${Shopify.routes.root}products/${productHandle}.js`)
        .then(data => data.json())
        .then(product => {
            // klaviyo tracking might not be enabled, we enclose it in a try/catch
            try {
                klaviyo.push(['track', 'Added to Cart', {
                    ProductID: product.id,
                    Name: product.title,
                    Price: price(product.price),
                    Brand: product.vendor,
                    ImageURL: product.featured_image || "",
                    URL: `https://www.universalstandard.com/products/${product.handle}`,
                    Value: product.price / 100
                }]);
            } catch (e) {
                console.log(e)
                // skip
            }
        });
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2);

    // Remove trailing zeros if no decimals or passed param is true
    if (total % 1 === 0 || removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // add commas if needed
    total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // return total
    return `${currency}${total}`;
}

// Add product to wishlist
async function addProductToWishlist(productID, variantID = null) {
    return window.Appmate.wk
        .toggleProduct(parseInt(productID))
        .then(function () {
        })
        .catch(console.error);
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

/**************
 AppMate
 ***************/
let wishlistProducts = [];

window.Appmate.wk.on({
    ready() {
        setTimeout(() => {
            const appmateLocalStorage = JSON.parse(
                window.localStorage.getItem("appmate-session")
            );

            wishlistProducts = appmateLocalStorage.cache.wishlists.data[0]?.products || []

            document.dispatchEvent(new CustomEvent("wishlistProductsLoaded"));
        }, 500);
    },
});

window.Appmate.init({
    app: {
        autoLoad: true,
    },
    shop: {
        domain: "universal-standard.myshopify.com",
    },
    session: {
        customerID,
        cacheScripts: true,
        expiration: 365,
    },
    wishlist: {
        loginRequired: false,
        handle: "/wishlist",
        share: {
            handle: "/wishlist/shared",
            title: "My Universal Standard Wishlist",
            description: "Here's my US wishlist!",
            imageTitle: "Universal Standard",
            hashTags: "wishlist",
            twitterUser: false,
        },
    },
});

function getWishlistProducts() {
    return wishlistProducts;
}

function getBaseProductHandle(handle) {
    return handle
        // finds the last hyphen (-) in the string
        .split(/-(?=[^-]+$)/)[0]
        // replaces spaces ( ), and dashes (—) with a hyphen (-)
        .replace(/[ –—]/g, '-')
        .toLowerCase()
}

function handleize(string) {
    /**
     * Handles are always lowercase
     * whitespace and special characters are replaced with a hyphen -.
     * If there are multiple consecutive whitespace or special characters, then they're replaced with a single hyphen.
     * Whitespace or special characters at the beginning are removed.
     */
    return string
        .toLowerCase()
        .replace(/^[^a-z0-9]+/, '')  // Remove leading non-alphanumeric characters
        .replace(/[^a-z0-9]+/g, '-') // Replace consecutive non-alphanumeric characters with a single hyphen
}

async function getGlobalColorSwatches() {
    const req = await fetch("https://cdn.universalstandard.com/color-swatch.json");
    return await req.json();
}

function getThemePreviewLink(){
    return `https://universalstandard.com?preview_theme_id=${Shopify.theme.id}`
}